import { Page } from "@/components/page";
import { createFileRoute } from "@tanstack/react-router";
import { scriptQueryOptions } from "@/api/fapinstructor/script/get-script";
import { useAuth } from "@clerk/clerk-react";
import { Title, Group, AppShell, Burger, Center } from "@mantine/core";
import { ScriptVoteButton } from "@/components/script/script-vote-button";
import { Outlet } from "@tanstack/react-router";
import { UnpublishScriptButton } from "./-components/unpublish-script-button";
import { PublishScriptButton } from "./-components/publish-script-button";
import { DeleteScriptButton } from "./-components/delete-script-button";
import { ScriptNavigation } from "./-components/script-navigation";
import { ScriptProgress } from "./-components/script-progress";
import { ScriptRulesModel } from "./-components/script-rules-model";
import { useNavigationDisclosure } from "@/hooks/use-navigation-disclosure";

export const Route = createFileRoute(
  "/_authenticated/_subscribed/script/$scriptId",
)({
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      scriptQueryOptions({ scriptId: opts.params.scriptId }),
    ),
  component: ScriptRouteComponent,
});

function ScriptRouteComponent() {
  const [opened, { toggle }] = useNavigationDisclosure();
  const script = Route.useLoaderData();
  const { userId } = useAuth();
  const isAuthor = userId === script.createdBy.id;

  return (
    <Page title="Script">
      <AppShell
        h="100%"
        styles={{
          main: {
            height: "100%",
          },
        }}
        header={{
          height: 55,
        }}
        navbar={{
          width: 200,
          breakpoint: "sm",
          collapsed: { mobile: !opened },
        }}
        padding="md"
      >
        <AppShell.Header>
          <Group justify="space-between" align="center" p="xs">
            <Group>
              <Burger
                opened={opened}
                onClick={toggle}
                hiddenFrom="sm"
                size="sm"
              />
              <Title size="h3">Script Builder</Title>
            </Group>
            <Group gap="xs">
              {!isAuthor ? (
                <ScriptVoteButton script={script} size="lg" />
              ) : null}
              {isAuthor && script.published ? (
                <UnpublishScriptButton scriptId={script.id} />
              ) : null}
              {isAuthor && !script.published ? (
                <PublishScriptButton scriptId={script.id} />
              ) : null}
              {isAuthor ? <DeleteScriptButton script={script} /> : null}
            </Group>
          </Group>
        </AppShell.Header>
        <AppShell.Navbar>
          <AppShell.Section grow>
            <ScriptNavigation scriptId={script.id} />
          </AppShell.Section>
          <AppShell.Section p="xs">
            <Center>
              <ScriptProgress value={script.triggerCoveragePercentage} />
            </Center>
          </AppShell.Section>
        </AppShell.Navbar>
        <AppShell.Main>
          <Outlet />
        </AppShell.Main>
        {isAuthor ? <ScriptRulesModel /> : null}
      </AppShell>
    </Page>
  );
}
